export const toDecimalPrecision = (value: number) => {
  const afterDotLen = value.toString().split('.')

  if (afterDotLen.length <= 1) return 0.001
  const amountArray = afterDotLen[1].split('')
  let step = '0.'

  for (let i = 0; i < amountArray.length; i++) {
    step += amountArray.length - 1 === i ? '1' : '0'
  }

  return +step < 1e-6 ? 0.000001 : +step < 0.001 ? +step : 0.001
}
